import { createApi } from '@reduxjs/toolkit/query/react';
import { tristarGamesBaseQueryFn } from '../baseQuery';
import type { ApiResponse, StyxConfig } from '../types';

export const styxApi = createApi({
  reducerPath: 'styxApi',
  baseQuery: tristarGamesBaseQueryFn,
  tagTypes: ['StyxConfig'],
  endpoints: (builder) => ({
    getStyxConfig: builder.query<ApiResponse<StyxConfig>, void>({
      query: () => ({
        url: 'api/player/v1/styx/config',
        method: 'GET',
      }),
      providesTags: ['StyxConfig'],
    }),
  }),
});

export const { useGetStyxConfigQuery } = styxApi;
